import { AssignmentTurnedIn } from "@mui/icons-material";
import { Box } from "@mui/material";
import ButtonIcon from "components/controls/buttons/ButtonIcon";
import { GraphStyle } from "components/planner/types";
import { buildGraphStyle } from "components/planner/utils";
import TasksDrawer from "pages/farms/planner/TasksDrawer";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import layoutSo from "stores/layout";
import locationSo from "stores/route/location";
import { PAGE_ID } from "stores/route/utils/types";
import theme from "styles/theme";
import PlannerLab from "./Planner";
import { useTranslation } from "react-i18next";
import plannerSo from "stores/planner";



const LabsPlannersPag: FunctionComponent = () => {

	// STORE
	//useStore(solutionLabSo)

	// HOOKs
	const [resizeStyle, setGanttStyle] = useState<GraphStyle>(() => buildGraphStyle({}))
	const { t } = useTranslation()

	useEffect(() => {
		locationSo.updatePageId(PAGE_ID.LABS_PLANNER)
		layoutSo.setTitle("PLANNER")
		// const load = async () => {
		// 	await farmSo.fetchAll()
		// 	await recipeSo.fetchAll()
		// 	await recipeSo.fetchAllFolderIfVoid()
		// }
		// load()
		// recipeSo.setSelect(null)
	}, [])



	/** cerco di ridimensionare il GANTT chiamata sul loading del componente HTML-GANTT */
	const measuredRef = useCallback((node: HTMLElement) => {
		if (!node) return
		const resizeObserver = new ResizeObserver((entries) => {
			for (const entry of entries) {
				if (entry.contentRect.height == 0 || entry.contentRect.width == 0) continue
				const newStyle = buildGraphStyle({
					height: entry.contentRect.height,
					width: entry.contentRect.width,
				}, resizeStyle)
				setGanttStyle(newStyle)
			}
		})
		resizeObserver.observe(node)
	}, []);

	// HANDLERs
	const handleDrawerTasks = () => plannerSo.setIsTaskDrawerOpen(true)

	// RENDER

	return <>


		<Box sx={cssContainer} tabIndex={0}>
			
			<div style={{ position: "relative" }}>
				<Box sx={sxButtonsIcons}>
					<Box sx={{ display: "flex", alignSelf: "center", marginRight: "8px" }}>
						<ButtonIcon sx={{ p: "5px" }}
							tooltip={t("pag.farm.planner.desk.task")}
							onClick={handleDrawerTasks}
						><AssignmentTurnedIn /></ButtonIcon>
					</Box>
				</Box>
			</div>

			<Box sx={cssPlanner} ref={measuredRef}>
				<PlannerLab style={resizeStyle} />
			</Box>
		</Box>

		<TasksDrawer />
	</>
}

export default LabsPlannersPag


const cssContainer = {
	height: "100%",
	display: "flex", flexDirection: "column",
	flex: "1 1 auto",
}
const cssPlanner = {
	marginTop: "5px",
	height: "100%",
	flex: "1 1 auto",
}
const sxButtonsIcons = {
	position: "absolute",
	top: 0,
	right: 0,
	zIndex: 10,
	display: "flex",
}